import { defineMessages } from 'react-intl';

export default defineMessages({
  noAuthTypeTitle: 'Tekniskt fel',
  noAuthTypeMessage: 'Vänligen försök igen senare',
  loadingErrorTitle: 'Oväntat fel',
  loadingErrorMessage: 'Något gick fel. Testa att ladda om sidan eller kontakta din vårdgivare.'
});
